module.exports = __webpack_public_path__ + "static/media/chat.084b07b6.svg";